module.exports = __webpack_public_path__ + "images/email/icon-calendar-9767eb8aa4143dd659d9150701e02d24.png";